export default __webpack_public_path__ + "static/newFeature-MenuItem-d9bd3fffd5fd87bc2de094f9fa917131.gif";